const validateName = (fullname: string | undefined) => {
  if (!fullname) return false;

  const names = fullname.split(' ');

  if (names.length < 2) return false;
  if (names.length === 2 && names[1] === '') return false;

  return true;
};

export default validateName;
